import React, { Suspense } from "react";
import { connect } from "react-redux";
import MenuLayout from "../../../menu/containers/MenuLayout";
import TemplateHeader from "../TemplateHeader/TemplateHeader";
import TemplateFooter from "../TemplateFooter/TemplateFooter";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { insertFonts } from "../../../../../helpers/fontHelper";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import MergeAlerter from "../../../../components/version/MergeAlerter";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { MediaBackdrop } from "../../components/MediaBackdrop/MediaBackdrop";
import "../styles/TemplateContent.css";
import ContentWrapper from "./Wrappers/ContentWrapper/ContentWrapper";
import MenuWrapper from "./Wrappers/MenuWrapper/MenuWrapper";
import HeaderWrapper from "./Wrappers/HeaderWrapper/HeaderWrapper";
import FooterWrapper from "./Wrappers/FooterWrapper/FooterWrapper";
import CmsSpeedDial from "../../../../components/CmsNavigation/CmsSpeedDial/CmsSpeedDial";

class TemplateWrapper extends React.Component {
  state = { prevBodyBGg: "", headerHeight: null };
  componentDidMount() {
    if (this.props.template !== undefined) {
      const { template, cms } = this.props;
      this.props.dispatch(cmsActions.getClientFonts(template.eventId));
    }
    if (
      this.props.cms.editMode === true &&
      this.props.cms.enviroment === sourceTypes.Template
    ) {
      document.addEventListener("click", this.handleClick, false);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.template !== undefined &&
      prevProps.template !== this.props.template
    ) {
      const { template, cms } = this.props;
      this.props.dispatch(cmsActions.getClientFonts(template.eventId));
    }
    if (this.headerRef !== undefined && this.state.headerRef === null) {
      this.setState({ headerHeight: this.headerRef.clientHeight });
    }
  }

  handleClick = (e) => {
    const { dispatch, selectedContainer, selectedElement } = this.props;
    if (
      (this.props.asideEditorRef &&
        this.props.asideEditorRef.contains(e.target)) ||
      (this.props.sidebarRef && this.props.sidebarRef.contains(e.target))
    ) {
      return;
    } else if (this.props.cms.deselectionBlocked) {
      return;
    }

    if (selectedContainer !== null) {
      if (
        selectedContainer.parentName === "FOOTER" &&
        !this.footerRef.contains(e.target)
      ) {
        dispatch(templateActions.deselect());
      }
    }
    if (selectedElement !== null) {
      if (
        selectedElement.parentName === "FOOTER" &&
        !this.footerRef.contains(e.target)
      ) {
        dispatch(templateActions.deselect());
      }
    }
    if (selectedContainer !== null) {
      if (
        selectedContainer.parentName === "HEADER" &&
        !this.headerRef.contains(e.target)
      ) {
        dispatch(templateActions.deselect());
      }
    }
    if (selectedElement !== null) {
      if (
        selectedElement.parentName === "HEADER" &&
        !this.headerRef.contains(e.target)
      ) {
        dispatch(templateActions.deselect());
      }
    }
  };
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  render() {
    const { template, cms, previewDevice } = this.props;
    const { editMode, fonts } = cms;
    if (template === undefined) return null;
    return (
      <div className="app">
        <MediaBackdrop
          device={previewDevice}
          url={template.content.main.youtubeUrl}
          main={template.content.main}
          enabled={template.content.main.videoBackgroundEnabled}
          editMode={editMode}
        >
          {editMode ? <CmsSpeedDial /> : null}
          {editMode ? <MergeAlerter /> : null}
          {fonts !== undefined && (
            <style
              dangerouslySetInnerHTML={{
                __html: insertFonts(this.props.cms.fonts),
              }}
            />
          )}
          <div
            style={{
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div ref={(r) => (this.headerRef = r)} id="temp-header">
              <HeaderWrapper>
                <TemplateHeader />
              </HeaderWrapper>
            </div>
          </div>
          <div style={{ justifyContent: "center", width: "100%" }}>
            <MenuWrapper>
              <MenuLayout headerHeight={this.headerRef} />
            </MenuWrapper>
          </div>
          <main className="not-inflicted">
            <ContentWrapper>{this.props.children}</ContentWrapper>
          </main>
          <div
            style={{
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div ref={(r) => (this.footerRef = r)}>
              <FooterWrapper>
                <TemplateFooter />
              </FooterWrapper>
            </div>
          </div>
        </MediaBackdrop>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template.template,
    previewDevice: state.template.previewDevice,
    selectedContainer: state.template.selectedContainer,
    selectedElement: state.template.selectedElement,
    cms: state.cms,
    isMenuModalOpen: state.template.isMenuModalOpen,
  };
}
export default connect(mapStateToProps)(TemplateWrapper);
